import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  plugins: [
    createPersistedState({
      paths: ["user", "selectedDomain"],
      storage: window.sessionStorage, //  Keeps data in sessionStorage
    }),
  ],

  state() {
    return {
      user: null,
      selectedDomain: "bb.bankbazaarinsurance.com"
    };
  },

  getters: {
    isAuthenticated: (state) => !!state.user,
    getUser: (state) => state.user,
    getSelectedDomain: (state) => state.selectedDomain,
    userEmail: (state) => state.user?.email || ""
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_SELECTED_DOMAIN(state, domain) {
      state.selectedDomain = domain;
    }
  },

  actions: {
    loginUser({ commit }, user) {
      commit("SET_USER", user);
    },

    logoutUser({ commit }) {
      commit("SET_USER", null);
    },

    updateSelectedDomain({ commit }, domain) {
      commit("SET_SELECTED_DOMAIN", domain);
    }
  },
});

export default store;